import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { AlertTriangle } from "lucide-react";

// Generic legal/trust page driven entirely by translations.
export default function LegalPage({ pageKey }) {
  const { t } = useLang();
  const page = t(`legal.${pageKey}`);
  const sections = page.sections || [];
  const today = new Date().toLocaleDateString();

  return (
    <div className="min-h-screen pt-28 pb-24 sm:pt-32">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid={`legal-title-${pageKey}`}>
          {page.title}
        </h1>
        <p className="mt-2 text-sm text-slate-500">{t("legal.updated")}: {today}</p>

        <div data-testid="legal-review-note" className="mt-6 flex gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4">
          <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
          <p className="text-sm leading-relaxed text-amber-800">{t("legal.reviewNote")}</p>
        </div>

        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-lg font-semibold text-slate-900">{s.h}</h2>
              <p className="mt-2 text-base leading-relaxed text-slate-500">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
